// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"660":"f4579f54","971":"0e6fd1b0"}[chunkId] + ".chunk.css";
};